import { useEffect, useMemo, useRef, useState } from "react";
import { useConfigStore } from "../../../../../../../../stores/ConfigStore";
import { useLanguage } from "../../../../../../../../stores/LanguageStore";
import { getFields } from "../../../../../../../../api/ContactAPI";
import { Button, Divider, Flex, Group, Stack } from "@mantine/core";
import TextEditor from "../../../../../../../../components/ExternalEditors/TextEditor";
import BackButton from "../../../../../../../../components/View/BackButton";
import { IconSend } from "@tabler/icons-react";
import ReplyGenerator from "../../../../../../models/emails/ReplyGenerator";
import { getPermission } from "../../../../../../../../functions/utilFunctions";
import ModelTemplateSender from "../../../../../../models/ModelTemplateSender";
import FilesModal from "../../../../../../files/FilesModal";
import FileItemMessage from "../../../../../../models/linkedin/FileItemMessage";

const LinkedinAnswerEditor = ({
  id,
  handleClose,
  handleSubmit,
  onInit,
  loading,
  disabled,
  isInvitation,
  lastLinkedinReply,
}) => {
  const lang = useLanguage((s) => s.language);
  const editorRef = useRef();

  const datafields = useConfigStore((s) => s.datafields);
  const datafieldTokens = useMemo(() => {
    let df = datafields.map((x) => ({
      label: x.name,
      value: x.identifier_placeholder,
    }));

    df = [
      {
        label: lang.components.variable_manager.dialog.signature_variable_name,
        value: "%signature%",
        name: lang.components.variable_manager.dialog.signature_variable_name,
      },
      ...df,
    ];

    return df;
  }, [datafields, lang]);
  const [file, setFile] = useState(null)
  const handleFileAdd = (content) => {
    setFile(content.item)
  }

  useEffect(() => {
    getFields();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    let text = "";

    text = editorRef?.current?.getContent({ format: "text" });

    return handleSubmit({
      text,
      file_id: file?.id,
    });
  };

  const onGenerated = (text) => {
    editorRef.current?.setContent(text);
  };

  const onImport = (model) => {
    editorRef.current?.setContent(model.text);

    if (model?.file_id) {
      let f = useConfigStore.getState().files_list.find(x => x.id === model.file_id);

      if (f) {
        setFile(f);
      }
    }
  };

  return (
    <Stack
      component={"form"}
      onSubmit={onSubmit}
      gap={0}
      id="model-form"
      w={"100%"}
      pos={"relative"}
      pt={8}
      style={{ border: "1px solid #00000012", borderRadius: 8 }}
    >
      <TextEditor
        id={id}
        editorRef={editorRef}
        placeholder={lang.resellers.messages.message_placeholder}
        tokens={datafieldTokens}
        toolbar={"undo redo | tokens |"}
        autoFocus
        autoSize
        disableDecor
        onInit={onInit}
        maxChars={9999}
      >
        <Group
          wrap="nowrap"
          style={{
            position: "absolute",
            top: 7,
            left: 64,
            zIndex: 4,
          }}
        >
          {getPermission("suggestedAnswerAi") && (
            <ReplyGenerator
              replyId={lastLinkedinReply?.id}
              onFinish={onGenerated}
              isLinkedin
            />
          )}
        </Group>
      </TextEditor>

      <Divider opacity={0.5} />
      {file && <div style={{ marginLeft: 16 }}> <FileItemMessage file={file} setFile={setFile} /></div>}

      <Group py={8} mx={8}>
        <Flex mr={"auto"}>
          <ModelTemplateSender
            type={isInvitation ? "linkedin_invitation" : "linkedin_message"}
            onImport={onImport}
          />
          {
            !isInvitation &&
            <FilesModal isLinkedin handleFileAdd={handleFileAdd} isLongButton buttonProps={{ size: "md", h: "auto", mx: "md" }} />
          }
        </Flex>


        <BackButton
          onClick={handleClose}
          label={lang.global.cancel}
          size="md"
        />

        <Button
          type="submit"
          rightSection={<IconSend size={18} />}
          size="md"
          loading={loading}
          disabled={disabled}
        >
          {lang.global.send}
        </Button>
      </Group>
    </Stack>
  );
};

export default LinkedinAnswerEditor;
